ClubProfileOpenHoursController.$inject = ['$scope', 'Club', 'CONST', 'Time', '_', 'alerts', 'User'];

/* @ngInject */
function ClubProfileOpenHoursController($scope, Club, CONST, Time, _, alerts, User) {
    var vm = this;
    vm.title = 'ClubProfileOpenHoursController';

    vm.loading = true;

    vm.open_hours = [];

    var weekdays = Time.moment.weekdays();
    weekdays[7] = 'Feriado';

    vm.dayName = function (day) {
        return weekdays[day];
    };

    vm.save = function () {
        alerts.code(null, null, User).then(save);
    };

    activate();

    ////////////////

    function activate() {
        vm.loading = true;

        Club.API.one('openhours')
            .customGET()
            .then(function (open_hours) {
                vm.open_hours = format_input(open_hours);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            })
    }

    function save(code) {
        var data = format_hours(vm);
        data.code = code;

        vm.loading = true;
        Club.API
            .customPOST(data, 'openhours')
            .then(function (res) {
                alerts.success('Exito', 'Horarios guardados exitosamente');
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }

    function format_hours(vm) {
        return {
            days: _.map(vm.open_hours, function (day) {
                return {
                    day_of_week: day.day_of_week,
                    open: day.open,
                    open_time: new Time.Hour().fromDate(day.open_time).toFloat(),
                    close_time: new Time.Hour().fromDate(day.close_time).toFloat()
                };
            })
        };
    }

    function format_input(open_hours) {
        return _.map(open_hours.plain(), function (day) {
            day.open = !!day.open;
            day.open_time = new Time.Hour().fromFloat(day.open_time).toDate();
            day.close_time = new Time.Hour().fromFloat(day.close_time).toDate();
            return day;
        });
    }

}

export default ClubProfileOpenHoursController;